/* MojaPizza - pametni predlogi v kosarici: glede na vsebino kosarice ponudi, kar manjka */
import Cart from "cart-store";

import { formatMoney } from "utils";

const MAX_SUGGESTIONS = 2;

// Vrstni red = prioriteta. "when" dobi funkcijo has(regex), ki preveri nazive izdelkov v kosarici.
const RULES = [
    { key: "kvas", when: (has) => has(/moka/i) && !has(/kvas|paket/i) },
    { key: "pokrov_eu", when: (has) => has(/posoda za testo eu/i) && !has(/pokrov za posodo 40x30/i) },
    { key: "pokrov_araven", when: (has) => has(/posoda za testo araven/i) && !has(/pokrov za testo araven/i) },
    { key: "riz", when: (has) => has(/brez glutena|brezglutensk/i) && !has(/riževa moka/i) },
    { key: "pelati", when: (has) => has(/moka/i) && !has(/pelati|paradižnik|polpa|paket/i) },
    { key: "semola", when: (has) => has(/moka/i) && !has(/semola|spolvero|paket|brez glutena|brezglutensk/i) },
];

const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

class CartSmartUpsell extends HTMLElement {
    connectedCallback() {
        const data = this.querySelector("[data-upsell-products]");
        try {
            this.products = data ? JSON.parse(data.textContent) : {};
        } catch (e) {
            this.products = {};
        }
        this.list = this.querySelector("[data-upsell-list]");
        this.list.addEventListener("click", this.#onClick);
        this.#render(Cart.getState().cart);
        this.unsubscribe = Cart.subscribe((state, prevState) => {
            if (state.cart !== prevState.cart) this.#render(state.cart);
        });
    }

    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
    }

    #suggestions(cart) {
        const items = (cart && cart.items) || [];
        if (!items.length) return [];
        const titles = items.map((item) => `${item.product_title} ${item.title || ""}`);
        const variantIds = items.map((item) => item.variant_id);
        const has = (re) => titles.some((t) => re.test(t));
        return RULES.filter((rule) => rule.when(has))
            .map((rule) => this.products[rule.key])
            .filter((product) => product && !variantIds.includes(product.id))
            .filter((product, index, all) => all.findIndex((p) => p.id === product.id) === index)
            .slice(0, MAX_SUGGESTIONS);
    }

    #render(cart) {
        const suggestions = this.#suggestions(cart);
        this.hidden = suggestions.length === 0;
        this.list.innerHTML = suggestions
            .map(
                (p) => `
            <div class="cart-smart-upsell__item">
              ${p.image ? `<img class="cart-smart-upsell__img" src="${escapeHtml(p.image)}" alt="" loading="lazy" width="48" height="48">` : ""}
              <div class="cart-smart-upsell__info">
                <a class="cart-smart-upsell__name" href="${escapeHtml(p.url)}">${escapeHtml(p.title)}</a>
                <span class="cart-smart-upsell__note">${escapeHtml(p.note)} · ${formatMoney(p.price, window.theme.money_format)}</span>
              </div>
              <button type="button" class="c-btn c-btn--primary cart-smart-upsell__btn" data-upsell-add="${p.id}">+ Dodaj</button>
            </div>`,
            )
            .join("");
    }

    #onClick = async (event) => {
        const button = event.target.closest("[data-upsell-add]");
        if (!button) return;
        button.disabled = true;
        try {
            await Cart.add({ id: Number(button.dataset.upsellAdd), quantity: 1 });
        } catch (e) {
            button.disabled = false;
        }
    };
}

if (!customElements.get("cart-smart-upsell")) {
    customElements.define("cart-smart-upsell", CartSmartUpsell);
}
